import {config} from "../config";
import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    required,
    TextInput,
    Pagination,
    Create,
    SimpleForm,
    useRedirect
} from 'react-admin';
import EditBtn from "./usersapi/editUserApiBtn";
import OMSDeleteRecordBtn from "./buttons/OMSDeleteRecordBtn";


/**
 * @type {{display: string, float: string, zIndex: number}}
 */
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const UsersPagination = props => <Pagination rowsPerPageOptions={[config.perPage]} {...props} />;

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export const UsersApiList = (props) => (
    <span>
        <List {...props}
              perPage={config.perPage}
              bulkActionButtons={false}
              pagination={<UsersPagination />}
              sort={{field: 'id', order: 'DESC'}}>
            <Datagrid>
                <TextField label="ID" source="id"/>
                <TextField label="Name" source="name"/>
                <TextField label="Role" source="role"/>
                <TextField label="Created At" source="created_at"/>
                <EditBtn />
                <DeleteUserBtn {...props}/>
            </Datagrid>
        </List>
    </span>
);

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export const UsersApiCreate = (props) => {
    const redirect = useRedirect();

    const handleSuccess = ({data}) => {
        alert("Please copy the following token: " + data.json.token);
        redirect('/user_api');
    };
    return (
        <span>
            <Create onSuccess={handleSuccess} title="Create Api Key" {...props}>
                <SimpleForm redirect={false}>
                    <TextInput label="Name" source="name" validate={required()}/>
                </SimpleForm>
            </Create>
        </span>
    );
};

const DeleteUserBtn = (props) => {
    let canDelete = (props.record.id !== Number(localStorage.getItem('user_id')));
    return canDelete ? <OMSDeleteRecordBtn permissionAllowed="user.delete" resource="user" {...props}/> : '';
};